// extracted by mini-css-extract-plugin
export default {"read-more":"TextTruncated_read-more__w-pSy"};